module.exports = __webpack_public_path__ + "img/307150.c02084cc.png";